<div role="dialog" aria-modal="true" aria-labelledby="modal-title-add-comment-topic">
<div class="modal-header">
  <h4 id="modal-title-add-comment-topic" class="modal-title">Add a new topic</h4>
  <button type="button" class="btn p-0 border-0 bg-transparent fs-4 lh-1" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label for="commentTopic">Topic</label>
    <select class="form-control" id="commentTopic" [(ngModel)]="selectedCommentTopic">
      <option *ngFor="let topic of availableTopics" [value]="topic">{{ topic }}</option>
    </select>
    <small class="form-text text-muted">Select a topic for this comment</small>
  </div>
  <div class="form-group">
    <label for="commentText">Comment</label>
    <textarea class="form-control" id="commentText" rows="4" [(ngModel)]="commentText" placeholder="Enter your comment here"></textarea>
    <small class="form-text text-muted">Enter your initial comment for this topic</small>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!isValid()" (click)="save()">Save</button>
</div>
</div>
